import type { StateCreator } from 'zustand';
import type { CostsOverview, FixedCost } from '../types';
import { costsApi } from '../services/costsApi';

export interface CostsSlice {
  costs: CostsOverview | null;
  costsLoading: boolean;
  costsDays: number;
  fetchCosts: (days?: number) => Promise<void>;
  createFixedCost: (data: Partial<FixedCost>) => Promise<void>;
  updateFixedCost: (id: number, data: Partial<FixedCost>) => Promise<void>;
  removeFixedCost: (id: number) => Promise<void>;
}

export const createCostsSlice: StateCreator<CostsSlice> = (set, get) => ({
  costs: null,
  costsLoading: false,
  costsDays: 30,

  fetchCosts: async (days) => {
    const d = days ?? get().costsDays;
    set({ costsLoading: true, costsDays: d });
    try {
      const data = await costsApi.get(d);
      set({ costs: data, costsLoading: false });
    } catch {
      set({ costsLoading: false });
    }
  },

  createFixedCost: async (data) => {
    await costsApi.createFixed(data);
    await get().fetchCosts();
  },

  updateFixedCost: async (id, data) => {
    await costsApi.updateFixed(id, data);
    await get().fetchCosts();
  },

  removeFixedCost: async (id) => {
    await costsApi.removeFixed(id);
    await get().fetchCosts();
  },
});
